export const urls = {
  checkout: {
    japan: '/ja/チェックアウト',
    english: '/checkout',
  },
  products: {
    japan: '/ja/私のアカウント/products',
    english: '/my-account/products',
  },
};
